import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { useMembershipActivation } from '../hooks/useMembershipActivation';
import MembershipListSelection from './MembershipListSelection';

const MembershipActivationButton = ({ 
  variant = "contained", 
  size = "small", 
  color = "primary",
  disabled = false,
  sx = {},
  autoFetch = true,
  ...props 
}) => {
  const {
    availableMemberships,
    membershipSelectionOpen,
    loading,
    fetchAvailableMemberships,
    handleMembershipButtonClick,
    handleMembershipConfirmation,
    closeMembershipSelection
  } = useMembershipActivation();

  useEffect(() => {
    if (autoFetch) {
      fetchAvailableMemberships();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoFetch]);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        color={color}
        onClick={handleMembershipButtonClick}
        disabled={disabled || loading || availableMemberships.length === 0}
        sx={sx}
        {...props}
      >
        {loading ? 'Caricamento...' : 
         availableMemberships.length > 0 ? 'Attiva Tesseramento' : 'Nessun tesseramento disponibile'}
      </Button>

      <MembershipListSelection
        open={membershipSelectionOpen}
        onClose={closeMembershipSelection}
        onConfirm={handleMembershipConfirmation}
      />
    </>
  );
};

export default MembershipActivationButton; 